/* eslint-disable @nx/enforce-module-boundaries */
import { Box, HStack, Stack } from '@mybridge/ui/layout';
import { Link } from '@mybridge/ui/link';
import { ReplyCountIcon, ReplyCountIconRTL } from '@mybridge/icons/comments';
import { Text } from '@mybridge/ui/text';
import { useContext, useState } from 'react';
import { PostCommentBox } from './comment';
import { Divider } from '@mybridge/ui/divider';
import { PostBoxContext } from 'v4/components/post/context';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useSelector } from 'react-redux';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
export const PostCommentRows = ({
  post,
  comments,
  commentBoxVisible=false,
  showCommentsDefault = false,
  level = 0,
  commentBoxExpanded,
  setCommentBoxExapnded
}) => {

  const { formatNumber } = useNumberFormatter()
  const [showComments, setShowComments] = useState(showCommentsDefault);
  const currentLanguage = useSelector((state) => state.translation.language) || 'en';
  const {
    post: thisPost,
    refetch,
    refetchComments,
    isFetchingComments,
    isLoadingComments
  } = useContext(PostBoxContext);
  const { comment_count } = thisPost ?? {};
  const handleShowComments = () => {
    setShowComments(!showComments);
  };
  const { t } = useTranslator();
  const direction = useDirection();

  const showExpander = level > 0 ? !showComments : true;
  
  return (
    <>
      {comments?.length > 0 ? (
        <>
          <Stack pb={4} spacing={0}>
            {showExpander ? (
              <HStack mt={1} pos="relative">
                {level > 0 ? (
                  <Box
                    borderBottom="2px solid"
                    // borderLeft="2px solid"
                    {...(direction === 'rtl') ? { borderRight: '2px solid' } : { borderLeft: '2px solid' }}
                    borderColor="gray.300"
                    pos="absolute"
                    top={commentBoxExpanded ? -40 : commentBoxVisible ? "calc(2.25rem * -5)" : -10}
                    h={commentBoxExpanded? "180px" : commentBoxVisible ? "204px" : 16}
                    // left={-9}
                    {...(direction === 'rtl') ? { right: -9 } : { left: -9 }}
                    w="9"
                    // borderBottomLeftRadius={10}
                    {...(direction === 'rtl') ? { borderBottomRightRadius: 10 } : { borderBottomLeftRadius: 10 }}
                  />
                ) : (
                  ''
                )}
                <Box
                  // borderRight="1px solid"
                  {...(direction === 'rtl') ? { borderLeft: '1px solid' } : { borderRight: '1px solid' }}
                  borderColor="gray.200"
                  pos="absolute"
                  top={-16}
                  // h={10}
                  // left={-9}
                  {...(direction === 'rtl') ? { right: -9 } : { left: -9 }}
                  w="1px"
                />
                <HStack>
                  {(level > 0 && direction === 'ltr') ? <ReplyCountIcon /> : (level > 0 && direction === 'rtl') ? <ReplyCountIconRTL /> : ''}
                  <Link
                    href="javascript:void(0);"
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    onClick={level > 0 ? handleShowComments : () => {}}
                  >
                    <Text {...(direction === 'rtl') ? { pl: 4 } : { pr: 4 }} py={2} fontSize="lg" fontWeight="medium">
                     {formatNumber(level > 0 ? comments?.length : comment_count)}  {t('post.comment')||"Comment"}
                      {((level > 0 ? comments?.length>1 : comment_count>1) && currentLanguage === 'en' ) ? 's' : ''}
                    </Text>
                  </Link>
                </HStack>
              </HStack>
            ) : (
              ''
            )}

            {showComments &&
              comments?.map?.((comment, cindex) => (
                <Stack key={comment?.id || cindex} spacing={0}>
                  <PostCommentBox
                    isLast={cindex >= comments.length - 1}
                    level={level + 1}
                    post={post}
                    key={comment?.id || cindex}
                    comment={comment}
                    commentList={comments}
                    refetch={() => {
                      refetchComments?.();
                      refetch?.();
                    }}
                    commentBoxExpanded={commentBoxExpanded}
                    setCommentBoxExapnded={setCommentBoxExapnded}
                  />
                </Stack>
              ))}
          </Stack>
        </>
      ) : (
        ''
      )}
    </>
  );
};
